module.exports = __webpack_public_path__ + "media/svg/tf-1639d924.svg";